import React from "react";
import "./multi-input.css";

const MultiInputField = ({
	field,
	value,
	onChange,
	error
}) => {
	const items = Array.isArray(value) ? value : [];

	const invalidItemsFromSubmit = Array.isArray(field.invalidItems)
		? field.invalidItems
		: [];

	const invalidItemsFromField = typeof field.validateItem === "function"
		? items.filter(item => !field.validateItem(item))
		: [];

	const invalidItems = [
		...new Set([
			...invalidItemsFromSubmit,
			...invalidItemsFromField
		])
	];

	const hasInvalidItems = invalidItems.length > 0;

	const isInvalidItem = item => {
		return invalidItems.includes(item);
	};

	const addItem = rawValue => {
		const item = String(rawValue || "").trim();

		if (!item || items.includes(item)) {
			return;
		}

		onChange(field.name, [...items, item]);
	};

	const removeItem = itemToRemove => {
		onChange(
			field.name,
			items.filter(item => item !== itemToRemove)
		);
	};

	const handleKeyDown = event => {
		if (!["Enter", "Tab", ","].includes(event.key)) {
			return;
		}

		event.preventDefault();
		addItem(event.target.value);
		event.target.value = "";
	};

	const handleBlur = event => {
		addItem(event.target.value);
		event.target.value = "";
	};

	const inputId = field.id || `${field.name}Input`;
	const hasError = error || hasInvalidItems;

	return (
		<div
			className={[
				"form-generic__multi-input",
				hasError ? "form-generic__multi-input--error" : ""
			].filter(Boolean).join(" ")}
		>
			<label
				className="form-generic__multi-input-label"
				htmlFor={inputId}
			>
				{field.label}
			</label>

			<div
				className={[
					"form-generic__multi-input-control",
					hasError ? "form-field__input--error" : ""
				].filter(Boolean).join(" ")}
			>
				{items.map(item => (
					<span
						key={item}
						className={[
							"form-generic__multi-input-chip",
							isInvalidItem(item)
								? "form-generic__multi-input-chip--error"
								: ""
						].filter(Boolean).join(" ")}
					>
						{item}

						<button
							type="button"
							onClick={() => removeItem(item)}
							disabled={field.disabled}
						>
							×
						</button>
					</span>
				))}

				<input
					id={inputId}
					name={field.name}
					type={field.inputType || "text"}
					placeholder={items.length === 0 ? field.placeholder : ""}
					onKeyDown={handleKeyDown}
					onBlur={handleBlur}
					disabled={field.disabled}
					className="form-generic__multi-input-text"
				/>
			</div>
		</div>
	);
};

export default MultiInputField;